<template>
	<Component
		:is="isSpan ? 'span' : 'p'"
		class="d-inline-flex mb-0 font-weight-semibold text-h6 amelipro-status"
		:class="statusClasses"
		:style="statusStyles"
	>
		{{ textValue }}
	</Component>
</template>

<script setup lang="ts">
	import { AmeliproStatusTypes } from './AmeliproStatusTypes';
	import { IndexedObject } from '../../types';
	import { computed } from 'vue';
	import { convertToHex } from '../../functions/convertToHex';

	const props = defineProps({
		isSpan: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: undefined,
		},
		paddingX: {
			type: String,
			default: '24px',
		},
		paddingY: {
			type: String,
			default: '12px',
		},
		type: {
			default: 'draft',
			type: String as () => keyof typeof AmeliproStatusTypes,
			validator(value: string): boolean {
				return ['action', 'archive', 'canceled', 'closed', 'draft', 'failure', 'progress', 'success'].includes(value.toLowerCase());
			},
		},
	});

	const statusClasses = computed(() => AmeliproStatusTypes[props.type].bgColor);

	const borderColorValue = computed(() => (AmeliproStatusTypes[props.type].borderColor || 'transparent'));

	const statusStyles = computed<IndexedObject>(() => ({
		border: `2px solid ${convertToHex(borderColorValue.value)}`,
		borderRadius: '16px',
		paddingBottom: `${props.paddingY}`,
		paddingLeft: `${props.paddingX}`,
		paddingRight: `${props.paddingX}`,
		paddingTop: `${props.paddingY}`,
	}));

	const textValue = computed(() => (props.label || AmeliproStatusTypes[props.type].defaultLabel));
</script>
<style lang="scss" scoped></style>
